// extracted by mini-css-extract-plugin
export default {"cardListBox":"CardList_cardListBox__HZlLH","rightBox":"CardList_rightBox__WSVbg"};